import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { getRearchiveUrl } from 'src/utils/rearchiveUrl';
import { tokenType } from 'src/services/tokenManagementService/constant';

/**
 * Calls Rearchive GET /api/v1/patients/access-check (SQ-58).
 * Returns true if response is 200 (patient found and user has access), false otherwise.
 */
export async function checkRearchivePatientAccess(
  mrn: string,
  facilityId: string
): Promise<boolean> {
  const base = getRearchiveUrl();
  if (!base || !mrn || !facilityId) return false;

  const url = new URL('/api/v1/patients/access-check', base.replace(/\/$/, ''));
  url.searchParams.set('mrn', mrn);
  url.searchParams.set('facility_id', facilityId);

  try {
    const token = await getAccessToken();
    const realm = getRealmName();
    const tenantId =
      typeof window !== 'undefined' && window.location?.hostname === 'localhost'
        ? (typeof localStorage !== 'undefined' && localStorage.getItem('realm')) || realm || ''
        : realm || '';

    const res = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        Authorization: `${tokenType} ${token}`,
        'X-Tenant-ID': tenantId,
      },
    });
    return res.ok;
  } catch {
    return false;
  }
}
